var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
var g,
    goog = goog || {},
    k = commonjsGlobal;

function m(a) {
  return "string" == typeof a;
}

function aa(a) {
  return "number" == typeof a;
}

function n(a, b) {
  a = a.split(".");
  b = b || k;

  for (var c = 0; c < a.length; c++) {
    if (b = b[a[c]], null == b) return null;
  }

  return b;
}

function ba() {}

function p(a) {
  var b = typeof a;
  if ("object" == b) {
    if (a) {
      if (a instanceof Array) return "array";
      if (a instanceof Object) return b;
      var c = Object.prototype.toString.call(a);
      if ("[object Window]" == c) return "object";
      if ("[object Array]" == c || "number" == typeof a.length && "undefined" != typeof a.splice && "undefined" != typeof a.propertyIsEnumerable && !a.propertyIsEnumerable("splice")) return "array";
      if ("[object Function]" == c || "undefined" != typeof a.call && "undefined" != typeof a.propertyIsEnumerable && !a.propertyIsEnumerable("call")) return "function";
    } else return "null";
  } else if ("function" == b && "undefined" == typeof a.call) return "object";
  return b;
}

function q(a) {
  return "array" == p(a);
}

function ca(a) {
  var b = p(a);
  return "array" == b || "object" == b && "number" == typeof a.length;
}

function r(a) {
  var b = typeof a;
  return "object" == b && null != a || "function" == b;
}

var t = "closure_uid_" + (1E9 * Math.random() >>> 0),
    da = 0;

function ea(a, b, c) {
  return a.call.apply(a.bind, arguments);
}

function fa(a, b, c) {
  if (!a) throw Error();

  if (2 < arguments.length) {
    var d = Array.prototype.slice.call(arguments, 2);
    return function () {
      var e = Array.prototype.slice.call(arguments);
      Array.prototype.unshift.apply(e, d);
      return a.apply(b, e);
    };
  }

  return function () {
    return a.apply(b, arguments);
  };
}

function u(a, b, c) {
  Function.prototype.bind && -1 != Function.prototype.bind.toString().indexOf("native code") ? u = ea : u = fa;
  return u.apply(null, arguments);
}

function v(a, b) {
  var c = Array.prototype.slice.call(arguments, 1);
  return function () {
    var d = c.slice();
    d.push.apply(d, arguments);
    return a.apply(this, d);
  };
}

var w = Date.now || function () {
  return +new Date();
};

function x(a, b) {
  function c() {}

  c.prototype = b.prototype;
  a.N = b.prototype;
  a.prototype = new c();
  a.prototype.constructor = a;

  a.yb = function (d, e, f) {
    for (var h = Array(arguments.length - 2), l = 2; l < arguments.length; l++) {
      h[l - 2] = arguments[l];
    }

    return b.prototype[e].apply(d, h);
  };
}

function y() {
  this.j = this.j;
  this.i = this.i;
}

var ha = 0;
y.prototype.j = !1;

y.prototype.la = function () {
  if (!this.j && (this.j = !0, this.G(), 0 != ha)) {
    var a = this[t] || (this[t] = ++da);
  }
};

y.prototype.G = function () {
  if (this.i) for (; this.i.length;) {
    this.i.shift()();
  }
};

var ja = Array.prototype.indexOf ? function (a, b) {
  return Array.prototype.indexOf.call(a, b, void 0);
} : function (a, b) {
  if (m(a)) return m(b) && 1 == b.length ? a.indexOf(b, 0) : -1;

  for (var c = 0; c < a.length; c++) {
    if (c in a && a[c] === b) return c;
  }

  return -1;
},
    la = Array.prototype.forEach ? function (a, b, c) {
  Array.prototype.forEach.call(a, b, c);
} : function (a, b, c) {
  for (var d = a.length, e = m(a) ? a.split("") : a, f = 0; f < d; f++) {
    f in e && b.call(c, e[f], f, a);
  }
};

function ma(a) {
  a: {
    var b = na;

    for (var c = a.length, d = m(a) ? a.split("") : a, e = 0; e < c; e++) {
      if (e in d && b.call(void 0, d[e], e, a)) {
        b = e;
        break a;
      }
    }

    b = -1;
  }

  return 0 > b ? null : m(a) ? a.charAt(b) : a[b];
}

function oa(a) {
  return Array.prototype.concat.apply([], arguments);
}

function pa(a) {
  var b = a.length;

  if (0 < b) {
    for (var c = Array(b), d = 0; d < b; d++) {
      c[d] = a[d];
    }

    return c;
  }

  return [];
}

function qa(a) {
  return /^[\s\xa0]*$/.test(a);
}

var ra = String.prototype.trim ? function (a) {
  return a.trim();
} : function (a) {
  return /^[\s\xa0]*([\s\S]*?)[\s\xa0]*$/.exec(a)[1];
};

function z(a, b) {
  return -1 != a.indexOf(b);
}

function sa(a, b) {
  return a < b ? -1 : a > b ? 1 : 0;
}

var A;

a: {
  var ta = k.navigator;

  if (ta) {
    var ua = ta.userAgent;

    if (ua) {
      A = ua;
      break a;
    }
  }

  A = "";
}

function va(a, b, c) {
  for (var d in a) {
    b.call(c, a[d], d, a);
  }
}

function wa(a) {
  var b = {},
      c;

  for (c in a) {
    b[c] = a[c];
  }

  return b;
}

var xa = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");

function ya(a, b) {
  for (var c, d, e = 1; e < arguments.length; e++) {
    d = arguments[e];

    for (c in d) {
      a[c] = d[c];
    }

    for (var f = 0; f < xa.length; f++) {
      c = xa[f], Object.prototype.hasOwnProperty.call(d, c) && (a[c] = d[c]);
    }
  }
}

function za(a) {
  za[" "](a);
  return a;
}

za[" "] = ba;

function Aa(a, b) {
  var c = Ba;
  return Object.prototype.hasOwnProperty.call(c, a) ? c[a] : c[a] = b(a);
}

var Ca = z(A, "Opera"),
    B = z(A, "Trident") || z(A, "MSIE"),
    Da = z(A, "Edge"),
    Ea = Da || B,
    Fa = z(A, "Gecko") && !(z(A.toLowerCase(), "webkit") && !z(A, "Edge")) && !(z(A, "Trident") || z(A, "MSIE")) && !z(A, "Edge"),
    Ga = z(A.toLowerCase(), "webkit") && !z(A, "Edge");

function Ha() {
  var a = k.document;
  return a ? a.documentMode : void 0;
}

var Ia;

a: {
  var Ja = "",
      Ka = function () {
    var a = A;
    if (Fa) return /rv:([^\);]+)(\)|;)/.exec(a);
    if (Da) return /Edge\/([\d\.]+)/.exec(a);
    if (B) return /\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(a);
    if (Ga) return /WebKit\/(\S+)/.exec(a);
    if (Ca) return /(?:Version)[ \/]?(\S+)/.exec(a);
  }();

  Ka && (Ja = Ka ? Ka[1] : "");

  if (B) {
    var La = Ha();

    if (null != La && La > parseFloat(Ja)) {
      Ia = String(La);
      break a;
    }
  }

  Ia = Ja;
}

var Ba = {};

function Ma(a) {
  return Aa(a, function () {
    for (var b = 0, c = ra(String(Ia)).split("."), d = ra(String(a)).split("."), e = Math.max(c.length, d.length), f = 0; 0 == b && f < e; f++) {
      var h = c[f] || "",
          l = d[f] || "";

      do {
        h = /(\d*)(\D*)(.*)/.exec(h) || ["", "", "", ""];
        l = /(\d*)(\D*)(.*)/.exec(l) || ["", "", "", ""];
        if (0 == h[0].length && 0 == l[0].length) break;
        b = sa(0 == h[1].length ? 0 : parseInt(h[1], 10), 0 == l[1].length ? 0 : parseInt(l[1], 10)) || sa(0 == h[2].length, 0 == l[2].length) || sa(h[2], l[2]);
        h = h[3];
        l = l[3];
      } while (0 == b);
    }

    return 0 <= b;
  });
}

var Na;
var Oa = k.document;
Na = Oa && B ? Ha() || ("CSS1Compat" == Oa.compatMode ? parseInt(Ia, 10) : 5) : void 0;

var Pa = !B || 9 <= Number(Na),
    Qa = B && !Ma("9"),
    Ra = function () {
  if (!k.addEventListener || !Object.defineProperty) return !1;
  var a = !1,
      b = Object.defineProperty({}, "passive", {
    get: function get() {
      a = !0;
    }
  });

  try {
    k.addEventListener("test", ba, b), k.removeEventListener("test", ba, b);
  } catch (c) {}

  return a;
}();

function C(a, b) {
  this.type = a;
  this.a = this.target = b;
  this.Ia = !0;
}

C.prototype.b = function () {
  this.Ia = !1;
};

function D(a, b) {
  C.call(this, a ? a.type : "");
  this.relatedTarget = this.a = this.target = null;
  this.button = this.screenY = this.screenX = this.clientY = this.clientX = 0;
  this.key = "";
  this.metaKey = this.shiftKey = this.altKey = this.ctrlKey = !1;
  this.pointerId = 0;
  this.pointerType = "";
  this.c = null;

  if (a) {
    var c = this.type = a.type,
        d = a.changedTouches && a.changedTouches.length ? a.changedTouches[0] : null;
    this.target = a.target || a.srcElement;
    this.a = b;

    if (b = a.relatedTarget) {
      if (Fa) {
        a: {
          try {
            za(b.nodeName);
            var e = !0;
            break a;
          } catch (f) {}

          e = !1;
        }

        e || (b = null);
      }
    } else "mouseover" == c ? b = a.fromElement : "mouseout" == c && (b = a.toElement);

    this.relatedTarget = b;
    d ? (this.clientX = void 0 !== d.clientX ? d.clientX : d.pageX, this.clientY = void 0 !== d.clientY ? d.clientY : d.pageY, this.screenX = d.screenX || 0, this.screenY = d.screenY || 0) : (this.clientX = void 0 !== a.clientX ? a.clientX : a.pageX, this.clientY = void 0 !== a.clientY ? a.clientY : a.pageY, this.screenX = a.screenX || 0, this.screenY = a.screenY || 0);
    this.button = a.button;
    this.key = a.key || "";
    this.ctrlKey = a.ctrlKey;
    this.altKey = a.altKey;
    this.shiftKey = a.shiftKey;
    this.metaKey = a.metaKey;
    this.pointerId = a.pointerId || 0;
    this.pointerType = m(a.pointerType) ? a.pointerType : Sa[a.pointerType] || "";
    this.c = a;
    a.defaultPrevented && this.b();
  }
}

x(D, C);
var Sa = {
  2: "touch",
  3: "pen",
  4: "mouse"
};

D.prototype.b = function () {
  D.N.b.call(this);
  var a = this.c;
  if (a.preventDefault) a.preventDefault();else if (a.returnValue = !1, Qa) try {
    if (a.ctrlKey || 112 <= a.keyCode && 123 >= a.keyCode) a.keyCode = -1;
  } catch (b) {}
};

var F = "closure_listenable_" + (1E6 * Math.random() | 0),
    Ta = 0;

function Ua(a, b, c, d, e) {
  this.listener = a;
  this.proxy = null;
  this.src = b;
  this.type = c;
  this.capture = !!d;
  this.da = e;
  this.key = ++Ta;
  this.X = this.Z = !1;
}

function Va(a) {
  a.X = !0;
  a.listener = null;
  a.proxy = null;
  a.src = null;
  a.da = null;
}

function Wa(a) {
  this.src = a;
  this.a = {};
  this.b = 0;
}

Wa.prototype.add = function (a, b, c, d, e) {
  var f = a.toString();
  a = this.a[f];
  a || (a = this.a[f] = [], this.b++);
  var h = Xa(a, b, d, e);
  -1 < h ? (b = a[h], c || (b.Z = !1)) : (b = new Ua(b, this.src, f, !!d, e), b.Z = c, a.push(b));
  return b;
};

function Ya(a, b) {
  var c = b.type;

  if (c in a.a) {
    var d = a.a[c],
        e = ja(d, b),
        f;
    (f = 0 <= e) && Array.prototype.splice.call(d, e, 1);
    f && (Va(b), 0 == a.a[c].length && (delete a.a[c], a.b--));
  }
}

function Xa(a, b, c, d) {
  for (var e = 0; e < a.length; ++e) {
    var f = a[e];
    if (!f.X && f.listener == b && f.capture == !!c && f.da == d) return e;
  }

  return -1;
}

var Za = "closure_lm_" + (1E6 * Math.random() | 0),
    $a = {};

function bb(a, b, c, d, e) {
  if (d && d.once) return cb(a, b, c, d, e);

  if (q(b)) {
    for (var f = 0; f < b.length; f++) {
      bb(a, b[f], c, d, e);
    }

    return null;
  }

  c = db(c);
  return a && a[F] ? a.za(b, c, r(d) ? !!d.capture : !!d, e) : eb(a, b, c, !1, d, e);
}

function eb(a, b, c, d, e, f) {
  if (!b) throw Error("Invalid event type");
  var h = r(e) ? !!e.capture : !!e;
  if (h && !Pa) return null;
  var l = fb(a);
  l || (a[Za] = l = new Wa(a));
  c = l.add(b, c, d, h, f);
  if (c.proxy) return c;
  d = gb();
  c.proxy = d;
  d.src = a;
  d.listener = c;
  if (a.addEventListener) Ra || (e = h), void 0 === e && (e = !1), a.addEventListener(b.toString(), d, e);else if (a.attachEvent) a.attachEvent(hb(b.toString()), d);else if (a.addListener && a.removeListener) a.addListener(d);else throw Error("addEventListener and attachEvent are unavailable.");
  return c;
}

function gb() {
  var a = ib,
      b = Pa ? function (c) {
    return a.call(b.src, b.listener, c);
  } : function (c) {
    c = a.call(b.src, b.listener, c);
    if (!c) return c;
  };
  return b;
}

function cb(a, b, c, d, e) {
  if (q(b)) {
    for (var f = 0; f < b.length; f++) {
      cb(a, b[f], c, d, e);
    }

    return null;
  }

  c = db(c);
  return a && a[F] ? a.Aa(b, c, r(d) ? !!d.capture : !!d, e) : eb(a, b, c, !0, d, e);
}

function jb(a, b, c, d, e) {
  if (q(b)) for (var f = 0; f < b.length; f++) {
    jb(a, b[f], c, d, e);
  } else (d = r(d) ? !!d.capture : !!d, c = db(c), a && a[F]) ? (a = a.c, b = String(b).toString(), b in a.a && (f = a.a[b], c = Xa(f, c, d, e), -1 < c && (Va(f[c]), Array.prototype.splice.call(f, c, 1), 0 == f.length && (delete a.a[b], a.b--)))) : a && (a = fb(a)) && (b = a.a[b.toString()], a = -1, b && (a = Xa(b, c, d, e)), (c = -1 < a ? b[a] : null) && kb(c));
}

function kb(a) {
  if (!aa(a) && a && !a.X) {
    var b = a.src;
    if (b && b[F]) Ya(b.c, a);else {
      var c = a.type,
          d = a.proxy;
      b.removeEventListener ? b.removeEventListener(c, d, a.capture) : b.detachEvent ? b.detachEvent(hb(c), d) : b.addListener && b.removeListener && b.removeListener(d);
      (c = fb(b)) ? (Ya(c, a), 0 == c.b && (c.src = null, b[Za] = null)) : Va(a);
    }
  }
}

function hb(a) {
  return a in $a ? $a[a] : $a[a] = "on" + a;
}

function lb(a, b) {
  var c = a.listener,
      d = a.da || a.src;
  a.Z && kb(a);
  return c.call(d, b);
}

function ib(a, b) {
  return a.X ? !0 : Pa ? lb(a, new D(b, this)) : (b = new D(b || n("window.event"), this), lb(a, b));
}

function fb(a) {
  a = a[Za];
  return a instanceof Wa ? a : null;
}

var mb = "__closure_events_fn_" + (1E9 * Math.random() >>> 0);

function db(a) {
  if ("function" == p(a)) return a;
  a[mb] || (a[mb] = function (b) {
    return a.handleEvent(b);
  });
  return a[mb];
}

function G() {
  y.call(this);
  this.c = new Wa(this);
  this.J = this;
  this.B = null;
}

x(G, y);
G.prototype[F] = !0;
g = G.prototype;

g.addEventListener = function (a, b, c, d) {
  bb(this, a, b, c, d);
};

g.removeEventListener = function (a, b, c, d) {
  jb(this, a, b, c, d);
};

g.dispatchEvent = function (a) {
  var b,
      c = this.B;
  if (c) for (b = []; c; c = c.B) {
    b.push(c);
  }
  c = this.J;
  var d = a.type || a;
  if (m(a)) a = new C(a, c);else if (a instanceof C) a.target = a.target || c;else {
    var e = a;
    a = new C(d, c);
    ya(a, e);
  }
  e = !0;
  if (b) for (var f = b.length - 1; 0 <= f; f--) {
    var h = a.a = b[f];
    e = nb(h, d, !0, a) && e;
  }
  h = a.a = c;
  e = nb(h, d, !0, a) && e;
  e = nb(h, d, !1, a) && e;
  if (b) for (f = 0; f < b.length; f++) {
    h = a.a = b[f], e = nb(h, d, !1, a) && e;
  }
  return e;
};

g.G = function () {
  G.N.G.call(this);

  if (this.c) {
    var a = this.c,
        c;

    for (c in a.a) {
      for (var d = a.a[c], e = 0; e < d.length; e++) {
        Va(d[e]);
      }

      delete a.a[c];
      a.b--;
    }
  }

  this.B = null;
};

g.za = function (a, b, c, d) {
  return this.c.add(String(a), b, !1, c, d);
};

g.Aa = function (a, b, c, d) {
  return this.c.add(String(a), b, !0, c, d);
};

function nb(a, b, c, d) {
  b = a.c.a[String(b)];
  if (!b) return !0;
  b = b.concat();

  for (var e = !0, f = 0; f < b.length; ++f) {
    var h = b[f];

    if (h && !h.X && h.capture == c) {
      var l = h.listener,
          E = h.da || h.src;
      h.Z && Ya(a.c, h);
      e = !1 !== l.call(E, d) && e;
    }
  }

  return e && 0 != d.Ia;
}

var ob = k.JSON.stringify;

function pb(a, b) {
  this.c = a;
  this.f = b;
  this.b = 0;
  this.a = null;
}

pb.prototype.get = function () {
  if (0 < this.b) {
    this.b--;
    var a = this.a;
    this.a = a.next;
    a.next = null;
  } else a = this.c();

  return a;
};

function qb() {
  this.b = this.a = null;
}

var sb = new pb(function () {
  return new rb();
}, function (a) {
  a.reset();
});

qb.prototype.add = function (a, b) {
  var c = sb.get();
  c.set(a, b);
  this.b ? this.b.next = c : this.a = c;
  this.b = c;
};

function tb() {
  var a = ub,
      b = null;
  a.a && (b = a.a, a.a = a.a.next, a.a || (a.b = null), b.next = null);
  return b;
}

function rb() {
  this.next = this.b = this.a = null;
}

rb.prototype.set = function (a, b) {
  this.a = a;
  this.b = b;
  this.next = null;
};

rb.prototype.reset = function () {
  this.next = this.b = this.a = null;
};

function vb(a) {
  k.setTimeout(function () {
    throw a;
  }, 0);
}

function wb(a, b) {
  xb || yb();
  zb || (xb(), zb = !0);
  ub.add(a, b);
}

var xb;

function yb() {
  var a = k.Promise.resolve(void 0);

  xb = function xb() {
    a.then(Ab);
  };
}

var zb = !1,
    ub = new qb();

function Ab() {
  for (var a; a = tb();) {
    try {
      a.a.call(a.b);
    } catch (c) {
      vb(c);
    }

    var b = sb;
    b.f(a);
    100 > b.b && (b.b++, a.next = b.a, b.a = a);
  }

  zb = !1;
}

function Cb(a, b) {
  G.call(this);
  this.b = a || 1;
  this.a = b || k;
  this.f = u(this.gb, this);
  this.g = w();
}

x(Cb, G);
g = Cb.prototype;
g.ba = !1;
g.L = null;

g.gb = function () {
  if (this.ba) {
    var a = w() - this.g;
    0 < a && a < .8 * this.b ? this.L = this.a.setTimeout(this.f, this.b - a) : (this.L && (this.a.clearTimeout(this.L), this.L = null), this.dispatchEvent("tick"), this.ba && (Db(this), this.start()));
  }
};

g.start = function () {
  this.ba = !0;
  this.L || (this.L = this.a.setTimeout(this.f, this.b), this.g = w());
};

function Db(a) {
  a.ba = !1;
  a.L && (a.a.clearTimeout(a.L), a.L = null);
}

g.G = function () {
  Cb.N.G.call(this);
  Db(this);
  delete this.a;
};

function Eb(a, b, c) {
  if ("function" == p(a)) c && (a = u(a, c));else if (a && "function" == typeof a.handleEvent) a = u(a.handleEvent, a);else throw Error("Invalid listener argument");
  return 2147483647 < Number(b) ? -1 : k.setTimeout(a, b || 0);
}

function Fb(a, b, c) {
  y.call(this);
  this.f = null != c ? u(a, c) : a;
  this.c = b;
  this.b = u(this.$a, this);
  this.a = [];
}

x(Fb, y);
g = Fb.prototype;
g.ea = !1;
g.U = null;

g.Ta = function (a) {
  this.a = arguments;
  this.U ? this.ea = !0 : Gb(this);
};

g.G = function () {
  Fb.N.G.call(this);
  this.U && (k.clearTimeout(this.U), this.U = null, this.ea = !1, this.a = []);
};

g.$a = function () {
  this.U = null;
  this.ea && (this.ea = !1, Gb(this));
};

function Gb(a) {
  a.U = Eb(a.b, a.c);
  a.f.apply(null, a.a);
}

function H(a) {
  y.call(this);
  this.b = a;
  this.a = {};
}

x(H, y);
var Hb = [];

function Ib(a, b, c, d) {
  q(c) || (c && (Hb[0] = c.toString()), c = Hb);

  for (var e = 0; e < c.length; e++) {
    var f = bb(b, c[e], d || a.handleEvent, !1, a.b || a);
    if (!f) break;
    a.a[f.key] = f;
  }
}

function Jb(a) {
  va(a.a, function (b, c) {
    this.a.hasOwnProperty(c) && kb(b);
  }, a);
  a.a = {};
}

H.prototype.G = function () {
  H.N.G.call(this);
  Jb(this);
};

H.prototype.handleEvent = function () {
  throw Error("EventHandler.handleEvent not implemented");
};

function Kb() {}

var I = new G();

function Lb(a) {
  C.call(this, "serverreachability", a);
}

x(Lb, C);

function J(a) {
  I.dispatchEvent(new Lb(I, a));
}

function Mb(a) {
  C.call(this, "statevent", a);
}

x(Mb, C);

function K(a) {
  I.dispatchEvent(new Mb(I, a));
}

function Nb(a) {
  C.call(this, "timingevent", a);
}

x(Nb, C);

function Ob(a, b) {
  if ("function" != p(a)) throw Error("Fn must not be null and must be a function");
  return k.setTimeout(function () {
    a();
  }, b);
}

var Pb = {
  NO_ERROR: 0,
  hb: 1,
  ob: 2,
  nb: 3,
  kb: 4,
  mb: 5,
  pb: 6,
  La: 7,
  TIMEOUT: 8,
  sb: 9
};
var Qb = {
  jb: "complete",
  wb: "success",
  Ma: "error",
  La: "abort",
  ub: "ready",
  vb: "readystatechange",
  TIMEOUT: "timeout",
  qb: "incrementaldata",
  tb: "progress",
  lb: "downloadprogress",
  xb: "uploadprogress"
};

function Rb() {}

Rb.prototype.a = null;

function Sb(a) {
  var b;
  (b = a.a) || (b = a.a = {});
  return b;
}

function Tb() {}

var L = {
  OPEN: "a",
  ib: "b",
  Ma: "c",
  rb: "d"
};

function Ub() {
  C.call(this, "d");
}

x(Ub, C);

function Vb() {
  C.call(this, "c");
}

x(Vb, C);
var Wb;

function Xb() {}

x(Xb, Rb);
Wb = new Xb();

function M(a, b, c) {
  this.g = a;
  this.W = b;
  this.V = c || 1;
  this.I = new H(this);
  this.O = Yb;
  a = Ea ? 125 : void 0;
  this.P = new Cb(a);
  this.h = null;
  this.b = !1;
  this.l = this.D = this.f = this.F = this.v = this.R = this.i = null;
  this.j = [];
  this.a = null;
  this.A = 0;
  this.c = this.w = null;
  this.o = -1;
  this.m = !1;
  this.J = 0;
  this.B = null;
  this.s = this.S = this.H = !1;
}

var Yb = 45E3,
    Zb = {},
    $b = {};
g = M.prototype;

g.setTimeout = function (a) {
  this.O = a;
};

function ac(a, b, c) {
  a.F = 1;
  a.f = bc(N(b));
  a.l = c;
  a.H = !0;
  cc(a, null);
}

function dc(a, b, c, d) {
  a.F = 1;
  a.f = bc(N(b));
  a.l = null;
  a.H = c;
  cc(a, d);
}

function cc(a, b) {
  a.v = w();
  ec(a);
  a.D = N(a.f);
  fc(a.D, "t", a.V);
  a.A = 0;
  a.a = a.g.$(a.g.Y() ? b : null);
  0 < a.J && (a.B = new Fb(u(a.Ja, a, a.a), a.J));
  Ib(a.I, a.a, "readystatechange", a.cb);
  b = a.h ? wa(a.h) : {};
  a.l ? (a.w || (a.w = "POST"), b["Content-Type"] = "application/x-www-form-urlencoded", a.a.ca(a.D, a.w, a.l, b)) : (a.w = "GET", a.a.ca(a.D, a.w, null, b));
  J(1);
}

g.cb = function (a) {
  a = a.target;
  var b = this.B;
  b && 3 == O(a) ? b.Ta() : this.Ja(a);
};

g.Ja = function (a) {
  try {
    if (a == this.a) a: {
      var b = O(this.a),
          c = this.a.ya(),
          d = this.a.T();

      if (!(3 > b || 3 == b && !Ea && !this.a.aa())) {
        this.m || 4 != b || 7 == c || (8 == c || 0 >= d ? J(3) : J(2));
        gc(this);
        var e = this.a.T();
        this.o = e;
        var f = this.a.aa();

        if (this.b = 200 == e) {
          if (this.S && !this.s) {
            b: {
              if (this.a) {
                var h = hc(this.a, "X-HTTP-Initial-Response");

                if (h && !qa(h)) {
                  var l = h;
                  break b;
                }
              }

              l = null;
            }

            if (l) this.s = !0, ic(this, l);else {
              this.b = !1;
              this.c = 3;
              K(12);
              P(this);
              jc(this);
              break a;
            }
          }

          this.H ? (kc(this, b, f), Ea && this.b && 3 == b && (Ib(this.I, this.P, "tick", this.bb), this.P.start())) : ic(this, f);
          4 == b && P(this);
          this.b && !this.m && (4 == b ? this.g.na(this) : (this.b = !1, ec(this)));
        } else 400 == e && 0 < f.indexOf("Unknown SID") ? (this.c = 3, K(12)) : (this.c = 0, K(13)), P(this), jc(this);
      }
    }
  } catch (E) {} finally {}
};

function kc(a, b, c) {
  for (var d = !0; !a.m && a.A < c.length;) {
    var e = lc(a, c);

    if (e == $b) {
      4 == b && (a.c = 4, K(14), d = !1);
      break;
    } else if (e == Zb) {
      a.c = 4;
      K(15);
      d = !1;
      break;
    } else ic(a, e);
  }

  4 == b && 0 == c.length && (a.c = 1, K(16), d = !1);
  a.b = a.b && d;
  d || (P(a), jc(a));
}

g.bb = function () {
  if (this.a) {
    var a = O(this.a),
        b = this.a.aa();
    this.A < b.length && (gc(this), kc(this, a, b), this.b && 4 != a && ec(this));
  }
};

function lc(a, b) {
  var c = a.A,
      d = b.indexOf("\n", c);
  if (-1 == d) return $b;
  c = Number(b.substring(c, d));
  if (isNaN(c)) return Zb;
  d += 1;
  if (d + c > b.length) return $b;
  b = b.substr(d, c);
  a.A = d + c;
  return b;
}

g.cancel = function () {
  this.m = !0;
  P(this);
};

function ec(a) {
  a.R = w() + a.O;
  mc(a, a.O);
}

function mc(a, b) {
  if (null != a.i) throw Error("WatchDog timer not null");
  a.i = Ob(u(a.ab, a), b);
}

function gc(a) {
  a.i && (k.clearTimeout(a.i), a.i = null);
}

g.ab = function () {
  this.i = null;
  var a = w();
  0 <= a - this.R ? (2 != this.F && (J(3), K(17)), P(this), this.c = 2, jc(this)) : mc(this, this.R - a);
};

function jc(a) {
  a.g.Ca() || a.m || a.g.na(a);
}

function P(a) {
  gc(a);
  var b = a.B;
  b && "function" == typeof b.la && b.la();
  a.B = null;
  Db(a.P);
  Jb(a.I);
  a.a && (b = a.a, a.a = null, b.abort(), b.la());
}

function ic(a, b) {
  try {
    a.g.Fa(a, b), J(4);
  } catch (c) {}
}

function nc(a) {
  if (a.C && "function" == typeof a.C) return a.C();
  if (m(a)) return a.split("");

  if (ca(a)) {
    for (var b = [], c = a.length, d = 0; d < c; d++) {
      b.push(a[d]);
    }

    return b;
  }

  b = [];
  c = 0;

  for (d in a) {
    b[c++] = a[d];
  }

  return b;
}

function oc(a, b) {
  if (a.forEach && "function" == typeof a.forEach) a.forEach(b, void 0);else if (ca(a) || m(a)) la(a, b, void 0);else {
    if (a.K && "function" == typeof a.K) var c = a.K();else if (a.C && "function" == typeof a.C) c = void 0;else if (ca(a) || m(a)) {
      c = [];

      for (var d = a.length, e = 0; e < d; e++) {
        c.push(e);
      }
    } else for (e in c = [], d = 0, a) {
      c[d++] = e;
    }
    d = nc(a);
    e = d.length;

    for (var f = 0; f < e; f++) {
      b.call(void 0, d[f], c && c[f], a);
    }
  }
}

function Q(a, b) {
  this.b = {};
  this.a = [];
  this.c = 0;
  var c = arguments.length;

  if (1 < c) {
    if (c % 2) throw Error("Uneven number of arguments");

    for (var d = 0; d < c; d += 2) {
      this.set(arguments[d], arguments[d + 1]);
    }
  } else if (a) if (a instanceof Q) for (c = a.K(), d = 0; d < c.length; d++) {
    this.set(c[d], a.get(c[d]));
  } else for (d in a) {
    this.set(d, a[d]);
  }
}

g = Q.prototype;

g.C = function () {
  pc(this);

  for (var a = [], b = 0; b < this.a.length; b++) {
    a.push(this.b[this.a[b]]);
  }

  return a;
};

g.K = function () {
  pc(this);
  return this.a.concat();
};

function qc(a) {
  a.b = {};
  a.a.length = 0;
  a.c = 0;
}

function rc(a, b) {
  R(a.b, b) && (delete a.b[b], a.c--, a.a.length > 2 * a.c && pc(a));
}

function pc(a) {
  if (a.c != a.a.length) {
    for (var b = 0, c = 0; b < a.a.length;) {
      var d = a.a[b];
      R(a.b, d) && (a.a[c++] = d);
      b++;
    }

    a.a.length = c;
  }

  if (a.c != a.a.length) {
    var e = {};

    for (c = b = 0; b < a.a.length;) {
      d = a.a[b], R(e, d) || (a.a[c++] = d, e[d] = 1), b++;
    }

    a.a.length = c;
  }
}

g.get = function (a, b) {
  return R(this.b, a) ? this.b[a] : b;
};

g.set = function (a, b) {
  R(this.b, a) || (this.c++, this.a.push(a));
  this.b[a] = b;
};

g.forEach = function (a, b) {
  for (var c = this.K(), d = 0; d < c.length; d++) {
    var e = c[d],
        f = this.get(e);
    a.call(b, f, e, this);
  }
};

function R(a, b) {
  return Object.prototype.hasOwnProperty.call(a, b);
}

var sc = /^(?:([^:/?#.]+):)?(?:\/\/(?:([^/?#]*)@)?([^/#?]*?)(?::([0-9]+))?(?=[/#?]|$))?([^?#]+)?(?:\?([^#]*))?(?:#([\s\S]*))?$/;

function tc(a, b) {
  if (a) {
    a = a.split("&");

    for (var c = 0; c < a.length; c++) {
      var d = a[c].indexOf("="),
          e = null;

      if (0 <= d) {
        var f = a[c].substring(0, d);
        e = a[c].substring(d + 1);
      } else f = a[c];

      b(f, e ? decodeURIComponent(e.replace(/\+/g, " ")) : "");
    }
  }
}

function S(a, b) {
  this.b = this.j = this.f = "";
  this.i = null;
  this.g = this.a = "";
  this.h = !1;
  var c;
  a instanceof S ? (this.h = void 0 !== b ? b : a.h, uc(this, a.f), this.j = a.j, vc(this, a.b), wc(this, a.i), this.a = a.a, xc(this, yc(a.c)), this.g = a.g) : a && (c = String(a).match(sc)) ? (this.h = !!b, uc(this, c[1] || "", !0), this.j = zc(c[2] || ""), vc(this, c[3] || "", !0), wc(this, c[4]), this.a = zc(c[5] || "", !0), xc(this, c[6] || "", !0), this.g = zc(c[7] || "")) : (this.h = !!b, this.c = new Ac(null, this.h));
}

S.prototype.toString = function () {
  var a = [],
      b = this.f;
  b && a.push(Bc(b, Cc, !0), ":");
  var c = this.b;
  if (c || "file" == b) a.push("//"), (b = this.j) && a.push(Bc(b, Cc, !0), "@"), a.push(encodeURIComponent(String(c)).replace(/%25([0-9a-fA-F]{2})/g, "%$1")), c = this.i, null != c && a.push(":", String(c));
  if (c = this.a) this.b && "/" != c.charAt(0) && a.push("/"), a.push(Bc(c, "/" == c.charAt(0) ? Dc : Ec, !0));
  (c = this.c.toString()) && a.push("?", c);
  (c = this.g) && a.push("#", Bc(c, Fc));
  return a.join("");
};

S.prototype.resolve = function (a) {
  var b = N(this),
      c = !!a.f;
  c ? uc(b, a.f) : c = !!a.j;
  c ? b.j = a.j : c = !!a.b;
  c ? vc(b, a.b) : c = null != a.i;
  var d = a.a;
  if (c) wc(b, a.i);else if (c = !!a.a) {
    if ("/" != d.charAt(0)) if (this.b && !this.a) d = "/" + d;else {
      var e = b.a.lastIndexOf("/");
      -1 != e && (d = b.a.substr(0, e + 1) + d);
    }
    e = d;
    if (".." == e || "." == e) d = "";else if (z(e, "./") || z(e, "/.")) {
      d = 0 == e.lastIndexOf("/", 0);
      e = e.split("/");

      for (var f = [], h = 0; h < e.length;) {
        var l = e[h++];
        "." == l ? d && h == e.length && f.push("") : ".." == l ? ((1 < f.length || 1 == f.length && "" != f[0]) && f.pop(), d && h == e.length && f.push("")) : (f.push(l), d = !0);
      }

      d = f.join("/");
    } else d = e;
  }
  c ? b.a = d : c = "" !== a.c.toString();
  c ? xc(b, yc(a.c)) : c = !!a.g;
  c && (b.g = a.g);
  return b;
};

function N(a) {
  return new S(a);
}

function uc(a, b, c) {
  a.f = c ? zc(b, !0) : b;
  a.f && (a.f = a.f.replace(/:$/, ""));
}

function vc(a, b, c) {
  a.b = c ? zc(b, !0) : b;
}

function wc(a, b) {
  if (b) {
    b = Number(b);
    if (isNaN(b) || 0 > b) throw Error("Bad port number " + b);
    a.i = b;
  } else a.i = null;
}

function xc(a, b, c) {
  b instanceof Ac ? (a.c = b, Gc(a.c, a.h)) : (c || (b = Bc(b, Hc)), a.c = new Ac(b, a.h));
}

function T(a, b, c) {
  a.c.set(b, c);
}

function fc(a, b, c) {
  q(c) || (c = [String(c)]);
  Ic(a.c, b, c);
}

function bc(a) {
  T(a, "zx", Math.floor(2147483648 * Math.random()).toString(36) + Math.abs(Math.floor(2147483648 * Math.random()) ^ w()).toString(36));
  return a;
}

function Jc(a) {
  return a instanceof S ? N(a) : new S(a, void 0);
}

function Kc(a, b, c, d) {
  var e = new S(null, void 0);
  a && uc(e, a);
  b && vc(e, b);
  c && wc(e, c);
  d && (e.a = d);
  return e;
}

function zc(a, b) {
  return a ? b ? decodeURI(a.replace(/%25/g, "%2525")) : decodeURIComponent(a) : "";
}

function Bc(a, b, c) {
  return m(a) ? (a = encodeURI(a).replace(b, Lc), c && (a = a.replace(/%25([0-9a-fA-F]{2})/g, "%$1")), a) : null;
}

function Lc(a) {
  a = a.charCodeAt(0);
  return "%" + (a >> 4 & 15).toString(16) + (a & 15).toString(16);
}

var Cc = /[#\/\?@]/g,
    Ec = /[#\?:]/g,
    Dc = /[#\?]/g,
    Hc = /[#\?@]/g,
    Fc = /#/g;

function Ac(a, b) {
  this.b = this.a = null;
  this.c = a || null;
  this.f = !!b;
}

function U(a) {
  a.a || (a.a = new Q(), a.b = 0, a.c && tc(a.c, function (b, c) {
    a.add(decodeURIComponent(b.replace(/\+/g, " ")), c);
  }));
}

g = Ac.prototype;

g.add = function (a, b) {
  U(this);
  this.c = null;
  a = V(this, a);
  var c = this.a.get(a);
  c || this.a.set(a, c = []);
  c.push(b);
  this.b += 1;
  return this;
};

function Mc(a, b) {
  U(a);
  b = V(a, b);
  R(a.a.b, b) && (a.c = null, a.b -= a.a.get(b).length, rc(a.a, b));
}

function Nc(a, b) {
  U(a);
  b = V(a, b);
  return R(a.a.b, b);
}

g.forEach = function (a, b) {
  U(this);
  this.a.forEach(function (c, d) {
    la(c, function (e) {
      a.call(b, e, d, this);
    }, this);
  }, this);
};

g.K = function () {
  U(this);

  for (var a = this.a.C(), b = this.a.K(), c = [], d = 0; d < b.length; d++) {
    for (var e = a[d], f = 0; f < e.length; f++) {
      c.push(b[d]);
    }
  }

  return c;
};

g.C = function (a) {
  U(this);
  var b = [];
  if (m(a)) Nc(this, a) && (b = oa(b, this.a.get(V(this, a))));else {
    a = this.a.C();

    for (var c = 0; c < a.length; c++) {
      b = oa(b, a[c]);
    }
  }
  return b;
};

g.set = function (a, b) {
  U(this);
  this.c = null;
  a = V(this, a);
  Nc(this, a) && (this.b -= this.a.get(a).length);
  this.a.set(a, [b]);
  this.b += 1;
  return this;
};

g.get = function (a, b) {
  if (!a) return b;
  a = this.C(a);
  return 0 < a.length ? String(a[0]) : b;
};

function Ic(a, b, c) {
  Mc(a, b);
  0 < c.length && (a.c = null, a.a.set(V(a, b), pa(c)), a.b += c.length);
}

g.toString = function () {
  if (this.c) return this.c;
  if (!this.a) return "";

  for (var a = [], b = this.a.K(), c = 0; c < b.length; c++) {
    var d = b[c],
        e = encodeURIComponent(String(d));
    d = this.C(d);

    for (var f = 0; f < d.length; f++) {
      var h = e;
      "" !== d[f] && (h += "=" + encodeURIComponent(String(d[f])));
      a.push(h);
    }
  }

  return this.c = a.join("&");
};

function yc(a) {
  var b = new Ac();
  b.c = a.c;
  a.a && (b.a = new Q(a.a), b.b = a.b);
  return b;
}

function V(a, b) {
  b = String(b);
  a.f && (b = b.toLowerCase());
  return b;
}

function Gc(a, b) {
  b && !a.f && (U(a), a.c = null, a.a.forEach(function (c, d) {
    var e = d.toLowerCase();
    d != e && (Mc(this, d), Ic(this, e, c));
  }, a));
  a.f = b;
}

function Qc() {}

function Rc() {}

x(Rc, Qc);

function Sc(a) {
  this.a = a;
  this.b = this.h = null;
  this.g = !1;
  this.i = null;
  this.c = -1;
  this.l = this.f = null;
}

g = Sc.prototype;
g.M = null;

function Uc(a) {
  var b = a.a.F.a;
  if (null != b) K(4), b ? (K(10), Vc(a.a, a, !1)) : (K(11), Vc(a.a, a, !0));else {
    a.b = new M(a, void 0, void 0);
    a.b.h = a.h;
    b = a.a;
    b = Wc(b, b.Y() ? a.f : null, a.i);
    K(4);
    fc(b, "TYPE", "xmlhttp");
    var c = a.a.j,
        d = a.a.I;
    c && d && T(b, c, d);
    dc(a.b, b, !1, a.f);
  }
}

g.$ = function (a) {
  return this.a.$(a);
};

g.abort = function () {
  this.b && (this.b.cancel(), this.b = null);
  this.c = -1;
};

g.Ca = function () {
  return !1;
};

g.Fa = function (a, b) {
  this.c = a.o;

  if (0 == this.M) {
    if (!this.a.o && (a = a.a)) {
      var c = hc(a, "X-Client-Wire-Protocol");
      this.l = c ? c : null;
      this.a.j && (a = hc(a, "X-HTTP-Session-Id")) && (this.a.I = a);
    }

    if (b) {
      try {
        var d = this.a.ja.a.parse(b);
      } catch (e) {
        b = this.a;
        b.m = this.c;
        W(b, 2);
        return;
      }

      this.f = d[0];
    } else b = this.a, b.m = this.c, W(b, 2);
  } else if (1 == this.M) if (this.g) K(6);else if ("11111" == b) {
    if (K(5), this.g = !0, !B || 10 <= Number(Na)) this.c = 200, this.b.cancel(), K(11), Vc(this.a, this, !0);
  } else K(7), this.g = !1;
};

g.na = function () {
  this.c = this.b.o;
  if (this.b.b) 0 == this.M ? (this.M = 1, Uc(this)) : 1 == this.M && (this.g ? (K(11), Vc(this.a, this, !0)) : (K(10), Vc(this.a, this, !1)));else {
    0 == this.M ? K(8) : 1 == this.M && K(9);
    var a = this.a;
    a.m = this.c;
    W(a, 2);
  }
};

g.Y = function () {
  return this.a.Y();
};

g.ma = function () {
  return this.a.ma();
};

function Xc() {
  this.a = this.b = null;
}

function Yc() {
  this.a = new Q();
}

function Zc(a) {
  var b = typeof a;
  return "object" == b && a || "function" == b ? "o" + (a[t] || (a[t] = ++da)) : b.charAt(0) + a;
}

Yc.prototype.add = function (a) {
  this.a.set(Zc(a), a);
};

Yc.prototype.C = function () {
  return this.a.C();
};

function $c(a, b) {
  this.b = a;
  this.a = b;
}

function ad(a) {
  this.g = a || bd;
  k.PerformanceNavigationTiming ? (a = k.performance.getEntriesByType("navigation"), a = 0 < a.length && ("hq" == a[0].nextHopProtocol || "h2" == a[0].nextHopProtocol)) : a = !!(k.ka && k.ka.Da && k.ka.Da() && k.ka.Da().zb);
  this.f = a ? this.g : 1;
  this.a = null;
  1 < this.f && (this.a = new Yc());
  this.b = null;
  this.c = [];
}

var bd = 10;

function cd(a, b) {
  !a.a && (z(b, "spdy") || z(b, "quic") || z(b, "h2")) && (a.f = a.g, a.a = new Yc(), a.b && (dd(a, a.b), a.b = null));
}

function ed(a) {
  return a.b ? !0 : a.a ? a.a.a.c >= a.f : !1;
}

function fd(a) {
  return a.b ? 1 : a.a ? a.a.a.c : 0;
}

function gd(a, b) {
  a.b ? a = a.b == b : a.a ? (b = Zc(b), a = R(a.a.a.b, b)) : a = !1;
  return a;
}

function dd(a, b) {
  a.a ? a.a.add(b) : a.b = b;
}

function hd(a, b) {
  if (a.b && a.b == b) a.b = null;else {
    var c;
    if (c = a.a) c = Zc(b), c = R(a.a.a.b, c);
    c && rc(a.a.a, Zc(b));
  }
}

ad.prototype.cancel = function () {
  this.c = id(this);
  this.b ? (this.b.cancel(), this.b = null) : this.a && 0 != this.a.a.c && (la(this.a.C(), function (a) {
    a.cancel();
  }), qc(this.a.a));
};

function id(a) {
  if (null != a.b) return a.c.concat(a.b.j);

  if (null != a.a && 0 != a.a.a.c) {
    var b = a.c;
    la(a.a.C(), function (c) {
      b = b.concat(c.j);
    });
    return b;
  }

  return pa(a.c);
}

function jd() {}

jd.prototype.stringify = function (a) {
  return k.JSON.stringify(a, void 0);
};

jd.prototype.parse = function (a) {
  return k.JSON.parse(a, void 0);
};

function kd() {
  this.a = new jd();
}

function ld(a, b, c) {
  var d = c || "";

  try {
    oc(a, function (e, f) {
      var h = e;
      r(e) && (h = ob(e));
      b.push(d + f + "=" + encodeURIComponent(h));
    });
  } catch (e) {
    throw b.push(d + "type=" + encodeURIComponent("_badmap")), e;
  }
}

function md(a, b) {
  var c = new Kb();

  if (k.Image) {
    var d = new Image();
    d.onload = v(nd, c, d, "TestLoadImage: loaded", !0, b);
    d.onerror = v(nd, c, d, "TestLoadImage: error", !1, b);
    d.onabort = v(nd, c, d, "TestLoadImage: abort", !1, b);
    d.ontimeout = v(nd, c, d, "TestLoadImage: timeout", !1, b);
    k.setTimeout(function () {
      if (d.ontimeout) d.ontimeout();
    }, 1E4);
    d.src = a;
  } else b(!1);
}

function nd(a, b, c, d, e) {
  try {
    b.onload = null, b.onerror = null, b.onabort = null, b.ontimeout = null, e(d);
  } catch (f) {}
}

var od = k.JSON.parse;

function X(a) {
  G.call(this);
  this.headers = new Q();
  this.H = a || null;
  this.b = !1;
  this.s = this.a = null;
  this.A = "";
  this.h = 0;
  this.f = "";
  this.g = this.w = this.l = this.v = !1;
  this.o = 0;
  this.m = null;
  this.I = pd;
  this.D = this.F = !1;
}

x(X, G);
var pd = "",
    qd = /^https?$/i,
    rd = ["POST", "PUT"];
g = X.prototype;

g.ca = function (a, b, c, d) {
  if (this.a) throw Error("[goog.net.XhrIo] Object is active with another request=" + this.A + "; newUri=" + a);
  b = b ? b.toUpperCase() : "GET";
  this.A = a;
  this.f = "";
  this.h = 0;
  this.v = !1;
  this.b = !0;
  this.a = new XMLHttpRequest();
  this.s = this.H ? Sb(this.H) : Sb(Wb);
  this.a.onreadystatechange = u(this.Ea, this);

  try {
    this.w = !0, this.a.open(b, String(a), !0), this.w = !1;
  } catch (f) {
    sd(this, f);
    return;
  }

  a = c || "";
  var e = new Q(this.headers);
  d && oc(d, function (f, h) {
    e.set(h, f);
  });
  d = ma(e.K());
  c = k.FormData && a instanceof k.FormData;
  !(0 <= ja(rd, b)) || d || c || e.set("Content-Type", "application/x-www-form-urlencoded;charset=utf-8");
  e.forEach(function (f, h) {
    this.a.setRequestHeader(h, f);
  }, this);
  this.I && (this.a.responseType = this.I);
  "withCredentials" in this.a && this.a.withCredentials !== this.F && (this.a.withCredentials = this.F);

  try {
    td(this), 0 < this.o && ((this.D = ud(this.a)) ? (this.a.timeout = this.o, this.a.ontimeout = u(this.Ba, this)) : this.m = Eb(this.Ba, this.o, this)), this.l = !0, this.a.send(a), this.l = !1;
  } catch (f) {
    sd(this, f);
  }
};

function ud(a) {
  return B && Ma(9) && aa(a.timeout) && void 0 !== a.ontimeout;
}

function na(a) {
  return "content-type" == a.toLowerCase();
}

g.Ba = function () {
  "undefined" != typeof goog && this.a && (this.f = "Timed out after " + this.o + "ms, aborting", this.h = 8, this.dispatchEvent("timeout"), this.abort(8));
};

function sd(a, b) {
  a.b = !1;
  a.a && (a.g = !0, a.a.abort(), a.g = !1);
  a.f = b;
  a.h = 5;
  vd(a);
  wd(a);
}

function vd(a) {
  a.v || (a.v = !0, a.dispatchEvent("complete"), a.dispatchEvent("error"));
}

g.abort = function (a) {
  this.a && this.b && (this.b = !1, this.g = !0, this.a.abort(), this.g = !1, this.h = a || 7, this.dispatchEvent("complete"), this.dispatchEvent("abort"), wd(this));
};

g.G = function () {
  this.a && (this.b && (this.b = !1, this.g = !0, this.a.abort(), this.g = !1), wd(this, !0));
  X.N.G.call(this);
};

g.Ea = function () {
  this.j || (this.w || this.l || this.g ? xd(this) : this.Za());
};

g.Za = function () {
  xd(this);
};

function xd(a) {
  if (a.b && "undefined" != typeof goog && (!a.s[1] || 4 != O(a) || 2 != a.T())) if (a.l && 4 == O(a)) Eb(a.Ea, 0, a);else if (a.dispatchEvent("readystatechange"), 4 == O(a)) {
    a.b = !1;

    try {
      var b = a.T();

      a: switch (b) {
        case 200:
        case 201:
        case 202:
        case 204:
        case 206:
        case 304:
        case 1223:
          var c = !0;
          break a;

        default:
          c = !1;
      }

      var d;

      if (!(d = c)) {
        var e;

        if (e = 0 === b) {
          var f = String(a.A).match(sc)[1] || null;

          if (!f && k.self && k.self.location) {
            var h = k.self.location.protocol;
            f = h.substr(0, h.length - 1);
          }

          e = !qd.test(f ? f.toLowerCase() : "");
        }

        d = e;
      }

      if (d) a.dispatchEvent("complete"), a.dispatchEvent("success");else {
        a.h = 6;

        try {
          var l = 2 < O(a) ? a.a.statusText : "";
        } catch (E) {
          l = "";
        }

        a.f = l + " [" + a.T() + "]";
        vd(a);
      }
    } finally {
      wd(a);
    }
  }
}

function wd(a, b) {
  if (a.a) {
    td(a);
    var c = a.a,
        d = a.s[0] ? ba : null;
    a.a = null;
    a.s = null;
    b || a.dispatchEvent("ready");

    try {
      c.onreadystatechange = d;
    } catch (e) {}
  }
}

function td(a) {
  a.a && a.D && (a.a.ontimeout = null);
  a.m && (k.clearTimeout(a.m), a.m = null);
}

function O(a) {
  return a.a ? a.a.readyState : 0;
}

g.T = function () {
  try {
    return 2 < O(this) ? this.a.status : -1;
  } catch (a) {
    return -1;
  }
};

g.aa = function () {
  try {
    return this.a ? this.a.responseText : "";
  } catch (a) {
    return "";
  }
};

g.Ua = function (a) {
  if (this.a) {
    var b = this.a.responseText;
    a && 0 == b.indexOf(a) && (b = b.substring(a.length));
    return od(b);
  }
};

function hc(a, b) {
  return a.a ? a.a.getResponseHeader(b) : null;
}

g.ya = function () {
  return this.h;
};

g.Xa = function () {
  return m(this.f) ? this.f : String(this.f);
};

function yd(a) {
  var b = "";
  va(a, function (c, d) {
    b += d;
    b += ":";
    b += c;
    b += "\r\n";
  });
  return b;
}

function zd(a, b, c) {
  a: {
    for (d in c) {
      var d = !1;
      break a;
    }

    d = !0;
  }

  if (d) return a;
  c = yd(c);

  if (m(a)) {
    b = encodeURIComponent(String(b));
    c = null != c ? "=" + encodeURIComponent(String(c)) : "";

    if (b += c) {
      c = a.indexOf("#");
      0 > c && (c = a.length);
      d = a.indexOf("?");

      if (0 > d || d > c) {
        d = c;
        var e = "";
      } else e = a.substring(d + 1, c);

      a = [a.substr(0, d), e, a.substr(c)];
      c = a[1];
      a[1] = b ? c ? c + "&" + b : b : c;
      a = a[0] + (a[1] ? "?" + a[1] : "") + a[2];
    }

    return a;
  }

  T(a, b, c);
  return a;
}

function Ad(a) {
  this.f = [];
  this.F = new Xc();
  this.ga = this.pa = this.B = this.ha = this.a = this.I = this.j = this.V = this.g = this.J = this.i = null;
  this.Qa = this.P = 0;
  this.Oa = !!n("internalChannelParams.failFast", a);
  this.ia = this.w = this.s = this.l = this.h = this.c = null;
  this.oa = !0;
  this.m = this.ra = this.O = -1;
  this.S = this.v = this.A = 0;
  this.Na = n("internalChannelParams.baseRetryDelayMs", a) || 5E3;
  this.Ra = n("internalChannelParams.retryDelaySeedMs", a) || 1E4;
  this.Pa = n("internalChannelParams.forwardChannelMaxRetries", a) || 2;
  this.qa = n("internalChannelParams.forwardChannelRequestTimeoutMs", a) || 2E4;
  this.Ka = a && a.Ab || void 0;
  this.D = void 0;
  this.R = a && a.supportsCrossDomainXhr || !1;
  this.H = "";
  this.b = new ad(a && a.concurrentRequestLimit);
  this.ja = new kd();
  this.o = a && void 0 !== a.backgroundChannelTest ? a.backgroundChannelTest : !0;
  (this.W = a && a.fastHandshake || !1) && !this.o && (this.o = !0);
  a && a.forceLongPolling && (this.oa = !1);
  this.fa = void 0;
}

g = Ad.prototype;
g.wa = 8;
g.u = 1;

function Bd(a) {
  Cd(a);

  if (3 == a.u) {
    var b = a.P++,
        c = N(a.B);
    T(c, "SID", a.H);
    T(c, "RID", b);
    T(c, "TYPE", "terminate");
    Dd(a, c);
    b = new M(a, b, void 0);
    b.F = 2;
    b.f = bc(N(c));
    c = !1;
    k.navigator && k.navigator.sendBeacon && (c = k.navigator.sendBeacon(b.f.toString(), ""));
    !c && k.Image && (new Image().src = b.f, c = !0);
    c || (b.a = b.g.$(null), b.a.ca(b.f));
    b.v = w();
    ec(b);
  }

  Ed(a);
}

function Cd(a) {
  a.w && (a.w.abort(), a.w = null);
  a.a && (a.a.cancel(), a.a = null);
  a.l && (k.clearTimeout(a.l), a.l = null);
  Fd(a);
  a.b.cancel();
  a.h && (aa(a.h) && k.clearTimeout(a.h), a.h = null);
}

function Gd(a, b) {
  a.f.push(new $c(a.Qa++, b));
  3 == a.u && Hd(a);
}

g.Ca = function () {
  return 0 == this.u;
};

function Hd(a) {
  ed(a.b) || a.h || (a.h = !0, wb(a.Ha, a), a.A = 0);
}

function Id(a, b) {
  if (fd(a.b) >= a.b.f - (a.h ? 1 : 0)) return !1;
  if (a.h) return a.f = b.j.concat(a.f), !0;
  if (1 == a.u || 2 == a.u || a.A >= (a.Oa ? 0 : a.Pa)) return !1;
  a.h = Ob(u(a.Ha, a, b), Jd(a, a.A));
  a.A++;
  return !0;
}

g.Ha = function (a) {
  if (this.h) if (this.h = null, 1 == this.u) {
    if (!a) {
      this.P = Math.floor(1E5 * Math.random());
      a = this.P++;
      var b = new M(this, a, void 0),
          c = this.i;
      this.J && (c ? (c = wa(c), ya(c, this.J)) : c = this.J);
      null === this.g && (b.h = c);
      var d;
      if (this.W) a: {
        for (var e = d = 0; e < this.f.length; e++) {
          b: {
            var f = this.f[e];

            if ("__data__" in f.a && (f = f.a.__data__, m(f))) {
              f = f.length;
              break b;
            }

            f = void 0;
          }

          if (void 0 === f) break;
          d += f;

          if (4096 < d) {
            d = e;
            break a;
          }

          if (4096 === d || e === this.f.length - 1) {
            d = e + 1;
            break a;
          }
        }

        d = 1E3;
      } else d = 1E3;
      d = Kd(this, b, d);
      e = N(this.B);
      T(e, "RID", a);
      T(e, "CVER", 22);
      this.o && this.j && T(e, "X-HTTP-Session-Id", this.j);
      Dd(this, e);
      this.g && c && zd(e, this.g, c);
      dd(this.b, b);
      this.W ? (T(e, "$req", d), T(e, "SID", "null"), b.S = !0, ac(b, e, null)) : ac(b, e, d);
      this.u = 2;
    }
  } else 3 == this.u && (a ? Ld(this, a) : 0 == this.f.length || ed(this.b) || Ld(this));
};

function Ld(a, b) {
  var c;
  b ? c = b.W : c = a.P++;
  var d = N(a.B);
  T(d, "SID", a.H);
  T(d, "RID", c);
  T(d, "AID", a.O);
  Dd(a, d);
  a.g && a.i && zd(d, a.g, a.i);
  c = new M(a, c, a.A + 1);
  null === a.g && (c.h = a.i);
  b && (a.f = b.j.concat(a.f));
  b = Kd(a, c, 1E3);
  c.setTimeout(Math.round(.5 * a.qa) + Math.round(.5 * a.qa * Math.random()));
  dd(a.b, c);
  ac(c, d, b);
}

function Dd(a, b) {
  a.c && oc({}, function (c, d) {
    T(b, d, c);
  });
}

function Kd(a, b, c) {
  c = Math.min(a.f.length, c);
  var d = a.c ? u(a.c.Sa, a.c, a) : null;

  a: for (var e = a.f, f = -1;;) {
    var h = ["count=" + c];
    -1 == f ? 0 < c ? (f = e[0].b, h.push("ofs=" + f)) : f = 0 : h.push("ofs=" + f);

    for (var l = !0, E = 0; E < c; E++) {
      var Bb = e[E].b,
          Tc = e[E].a;
      Bb -= f;
      if (0 > Bb) f = Math.max(0, e[E].b - 100), l = !1;else try {
        ld(Tc, h, "req" + Bb + "_");
      } catch (Ud) {
        d && d(Tc);
      }
    }

    if (l) {
      d = h.join("&");
      break a;
    }
  }

  a = a.f.splice(0, c);
  b.j = a;
  return d;
}

function Md(a) {
  a.a || a.l || (a.S = 1, wb(a.Ga, a), a.v = 0);
}

function Nd(a) {
  if (a.a || a.l || 3 <= a.v) return !1;
  a.S++;
  a.l = Ob(u(a.Ga, a), Jd(a, a.v));
  a.v++;
  return !0;
}

g.Ga = function () {
  this.l = null;
  this.a = new M(this, "rpc", this.S);
  null === this.g && (this.a.h = this.i);
  this.a.J = 0;
  var a = N(this.pa);
  T(a, "RID", "rpc");
  T(a, "SID", this.H);
  T(a, "CI", this.ia ? "0" : "1");
  T(a, "AID", this.O);
  Dd(this, a);
  T(a, "TYPE", "xmlhttp");
  this.g && this.i && zd(a, this.g, this.i);
  this.D && this.a.setTimeout(this.D);
  dc(this.a, a, !0, this.ga);
};

function Vc(a, b, c) {
  var d = b.l;
  d && cd(a.b, d);
  a.ia = a.oa && c;
  a.m = b.c;
  a.B = Wc(a, null, a.ha);
  Hd(a);
}

g.Fa = function (a, b) {
  if (0 != this.u && (this.a == a || gd(this.b, a))) if (this.m = a.o, !a.s && gd(this.b, a) && 3 == this.u) {
    try {
      var c = this.ja.a.parse(b);
    } catch (f) {
      c = null;
    }

    if (q(c) && 3 == c.length) {
      b = c;
      if (0 == b[0]) a: {
        if (!this.l) {
          if (this.a) if (this.a.v + 3E3 < a.v) Fd(this), this.a.cancel(), this.a = null;else break a;
          Nd(this);
          K(18);
        }
      } else this.ra = b[1], 0 < this.ra - this.O && 37500 > b[2] && this.ia && 0 == this.v && !this.s && (this.s = Ob(u(this.Ya, this), 6E3));

      if (1 >= fd(this.b) && this.fa) {
        try {
          this.fa();
        } catch (f) {}

        this.fa = void 0;
      }
    } else W(this, 11);
  } else if ((a.s || this.a == a) && Fd(this), !qa(b)) for (b = c = this.ja.a.parse(b), c = 0; c < b.length; c++) {
    var d = b[c];
    this.O = d[0];
    d = d[1];
    if (2 == this.u) {
      if ("c" == d[0]) {
        this.H = d[1];
        this.ga = d[2];
        var e = d[3];
        null != e && (this.wa = e);
        d = d[5];
        null != d && aa(d) && 0 < d && (this.D = 1.5 * d);
        this.o && (d = a.a) && ((e = hc(d, "X-Client-Wire-Protocol")) && cd(this.b, e), this.j && (d = hc(d, "X-HTTP-Session-Id"))) && (this.I = d, T(this.B, this.j, d));
        this.u = 3;
        this.c && this.c.va();
        d = a;
        this.pa = Wc(this, this.Y() ? this.ga : null, this.ha);
        d.s ? (hd(this.b, d), (e = this.D) && d.setTimeout(e), d.i && (gc(d), ec(d)), this.a = d) : Md(this);
        0 < this.f.length && Hd(this);
      } else "stop" != d[0] && "close" != d[0] || W(this, 7);
    } else 3 == this.u && ("stop" == d[0] || "close" == d[0] ? "stop" == d[0] ? W(this, 7) : Bd(this) : "noop" != d[0] && this.c && this.c.ua(d), this.v = 0);
  }
};

g.Ya = function () {
  null != this.s && (this.s = null, this.a.cancel(), this.a = null, Nd(this), K(19));
};

function Fd(a) {
  null != a.s && (k.clearTimeout(a.s), a.s = null);
}

g.na = function (a) {
  var b = null;

  if (this.a == a) {
    Fd(this);
    this.a = null;
    var c = 2;
  } else if (gd(this.b, a)) b = a.j, hd(this.b, a), c = 1;else return;

  this.m = a.o;
  if (0 != this.u) if (a.b) 1 == c ? (b = w() - a.v, I.dispatchEvent(new Nb(I, a.l ? a.l.length : 0, b, this.A)), Hd(this)) : Md(this);else {
    var d = a.c;
    if (3 == d || 0 == d && 0 < this.m || !(1 == c && Id(this, a) || 2 == c && Nd(this))) switch (b && 0 < b.length && (a = this.b, a.c = a.c.concat(b)), d) {
      case 1:
        W(this, 5);
        break;

      case 4:
        W(this, 10);
        break;

      case 3:
        W(this, 6);
        break;

      default:
        W(this, 2);
    }
  }
};

function Jd(a, b) {
  var c = a.Na + Math.floor(Math.random() * a.Ra);
  a.ma() || (c *= 2);
  return c * b;
}

function W(a, b) {
  if (2 == b) {
    var c = null;
    a.c && (c = null);
    var d = u(a.eb, a);
    c || (c = new S("//www.google.com/images/cleardot.gif"), k.location && "http" == k.location.protocol || uc(c, "https"), bc(c));
    md(c.toString(), d);
  } else K(2);

  a.u = 0;
  a.c && a.c.ta(b);
  Ed(a);
  Cd(a);
}

g.eb = function (a) {
  a ? K(2) : K(1);
};

function Ed(a) {
  a.u = 0;
  a.m = -1;

  if (a.c) {
    if (0 != id(a.b).length || 0 != a.f.length) a.b.c.length = 0, pa(a.f), a.f.length = 0;
    a.c.sa();
  }
}

function Wc(a, b, c) {
  var d = Jc(c);
  if ("" != d.b) b && vc(d, b + "." + d.b), wc(d, d.i);else {
    var e = k.location,
        f;
    b ? f = b + "." + e.hostname : f = e.hostname;
    d = Kc(e.protocol, f, +e.port, c);
  }
  a.V && va(a.V, function (h, l) {
    T(d, l, h);
  });
  b = a.j;
  c = a.I;
  b && c && T(d, b, c);
  T(d, "VER", a.wa);
  Dd(a, d);
  return d;
}

g.$ = function (a) {
  if (a && !this.R) throw Error("Can't create secondary domain capable XhrIo object.");
  a = new X(this.Ka);
  a.F = this.R;
  return a;
};

g.ma = function () {
  return !!this.c && !0;
};

g.Y = function () {
  return this.R;
};

function Od() {}

g = Od.prototype;

g.va = function () {};

g.ua = function () {};

g.ta = function () {};

g.sa = function () {};

g.Sa = function () {};

function Pd(a) {
  for (var b = arguments[0], c = 1; c < arguments.length; c++) {
    var d = arguments[c];
    if (0 == d.lastIndexOf("/", 0)) b = d;else {
      var e;
      (e = "" == b) || (e = b.length - 1, e = 0 <= e && b.indexOf("/", e) == e);
      e ? b += d : b += "/" + d;
    }
  }

  return b;
}

function Qd() {
  if (B && !(10 <= Number(Na))) throw Error("Environmental error: no available transport.");
}

Qd.prototype.a = function (a, b) {
  return new Y(a, b);
};

function Y(a, b) {
  G.call(this);
  this.a = new Ad(b);
  this.g = a;
  this.m = b && b.fb ? b.fb : Pd(this.g, "test");
  this.b = b && b.messageUrlParams || null;
  a = b && b.messageHeaders || null;
  b && b.clientProtocolHeaderRequired && (a ? a["X-Client-Protocol"] = "webchannel" : a = {
    "X-Client-Protocol": "webchannel"
  });
  this.a.i = a;
  a = b && b.initMessageHeaders || null;
  b && b.messageContentType && (a ? a["X-WebChannel-Content-Type"] = b.messageContentType : a = {
    "X-WebChannel-Content-Type": b.messageContentType
  });
  b && b.xa && (a ? a["X-WebChannel-Client-Profile"] = b.xa : a = {
    "X-WebChannel-Client-Profile": b.xa
  });
  this.a.J = a;
  (a = b && b.httpHeadersOverwriteParam) && !qa(a) && (this.a.g = a);
  this.l = b && b.supportsCrossDomainXhr || !1;
  this.h = b && b.sendRawJson || !1;
  (b = b && b.httpSessionIdParam) && !qa(b) && (this.a.j = b, a = this.b, null !== a && b in a && (a = this.b, b in a && delete a[b]));
  this.f = new Z(this);
}

x(Y, G);
g = Y.prototype;

g.addEventListener = function (a, b, c, d) {
  Y.N.addEventListener.call(this, a, b, c, d);
};

g.removeEventListener = function (a, b, c, d) {
  Y.N.removeEventListener.call(this, a, b, c, d);
};

g.Va = function () {
  this.a.c = this.f;
  this.l && (this.a.R = !0);
  var a = this.a,
      b = this.m,
      c = this.g,
      d = this.b || void 0;
  K(0);
  a.ha = c;
  a.V = d || {};
  a.o && (a.F.b = [], a.F.a = !1);
  a.w = new Sc(a);
  null === a.g && (a.w.h = a.i);
  c = b;
  a.g && a.i && (c = zd(b, a.g, a.i));
  a = a.w;
  a.i = c;
  b = Wc(a.a, null, a.i);
  K(3);
  c = a.a.F.b;
  null != c ? (a.f = c[0], a.M = 1, Uc(a)) : (fc(b, "MODE", "init"), !a.a.o && a.a.j && fc(b, "X-HTTP-Session-Id", a.a.j), a.b = new M(a, void 0, void 0), a.b.h = a.h, dc(a.b, b, !1, null), a.M = 0);
};

g.close = function () {
  Bd(this.a);
};

g.Wa = function (a) {
  if (m(a)) {
    var b = {};
    b.__data__ = a;
    Gd(this.a, b);
  } else this.h ? (b = {}, b.__data__ = ob(a), Gd(this.a, b)) : Gd(this.a, a);
};

g.G = function () {
  this.a.c = null;
  delete this.f;
  Bd(this.a);
  delete this.a;
  Y.N.G.call(this);
};

function Rd(a) {
  Ub.call(this);
  var b = a.__sm__;

  if (b) {
    a: {
      for (var c in b) {
        a = c;
        break a;
      }

      a = void 0;
    }

    (this.c = a) ? (a = this.c, this.data = null !== b && a in b ? b[a] : void 0) : this.data = b;
  } else this.data = a;
}

x(Rd, Ub);

function Sd() {
  Vb.call(this);
  this.status = 1;
}

x(Sd, Vb);

function Z(a) {
  this.a = a;
}

x(Z, Od);

Z.prototype.va = function () {
  this.a.dispatchEvent("a");
};

Z.prototype.ua = function (a) {
  this.a.dispatchEvent(new Rd(a));
};

Z.prototype.ta = function (a) {
  this.a.dispatchEvent(new Sd(a));
};

Z.prototype.sa = function () {
  this.a.dispatchEvent("b");
};

var Td = v(function (a, b) {
  function c() {}

  c.prototype = a.prototype;
  var d = new c();
  a.apply(d, Array.prototype.slice.call(arguments, 1));
  return d;
}, Qd);
/*
Copyright 2017 Google Inc.
Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at
http://www.apache.org/licenses/LICENSE-2.0
Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

Qd.prototype.createWebChannel = Qd.prototype.a;
Y.prototype.send = Y.prototype.Wa;
Y.prototype.open = Y.prototype.Va;
Y.prototype.close = Y.prototype.close;
Pb.NO_ERROR = 0;
Pb.TIMEOUT = 8;
Pb.HTTP_ERROR = 6;
Qb.COMPLETE = "complete";
Tb.EventType = L;
L.OPEN = "a";
L.CLOSE = "b";
L.ERROR = "c";
L.MESSAGE = "d";
G.prototype.listen = G.prototype.za;
X.prototype.listenOnce = X.prototype.Aa;
X.prototype.getLastError = X.prototype.Xa;
X.prototype.getLastErrorCode = X.prototype.ya;
X.prototype.getStatus = X.prototype.T;
X.prototype.getResponseJson = X.prototype.Ua;
X.prototype.getResponseText = X.prototype.aa;
X.prototype.send = X.prototype.ca;
var tmp = {
  createWebChannelTransport: Td,
  ErrorCode: Pb,
  EventType: Qb,
  WebChannel: Tb,
  XhrIo: X
};
var tmp_1 = tmp.createWebChannelTransport;
var tmp_2 = tmp.ErrorCode;
var tmp_3 = tmp.EventType;
var tmp_4 = tmp.WebChannel;
var tmp_5 = tmp.XhrIo;
export default tmp;
export { tmp_2 as ErrorCode, tmp_3 as EventType, tmp_4 as WebChannel, tmp_5 as XhrIo, tmp_1 as createWebChannelTransport };